import React from 'react';
import _ from 'lodash';
import { getTeamUrl } from '../../../utils/routes';
import { getProxyUrl } from '../../../utils/image';
import { numberFormat } from '../../../utils/numberFormat';
import Form from './Form';

function TeamsTableRow({ team, i, orderBy }) {
  const getTeamLogo = () => {
    return team?.logoImage
      ? getProxyUrl(team?.logoImage, 50, 50)
      : '/wp-content/themes/sef-leagues/images/generic-team.png';
  };
  const stats = _.isNumber(team[orderBy])
    ? numberFormat(team[orderBy])
    : team[orderBy];

  return (
    <>
      {i === 1 ? (
        <div
          className="player-bust d-md-none pb-0"
          style={{ margin: '0 auto 20px auto', width: '180px' }}
        >
          <div className="player-bust__images">
            <img
              className="player-bust__player-image"
              src={team?.logoImage}
              alt={team?.displayName}
              style={{ width: '120px' }}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      <div
        className={`stats-table__row ${
          team?.ranking === 1 ? 'bg-comp-pink' : ''
        }`}
      >
        <div className="col-1 text-center stats-font-larger stats-font-adjust">
          {team?.ranking}
        </div>
        <a
          href={getTeamUrl(team?.abbrv)}
          className="col-7 col-md-6 name-with-team-logo"
        >
          <div className="name-with-team-logo name-with-team-logo">
            <img alt="teamlogo" src={getTeamLogo()} />
            <span className="d-none d-sm-inline-block text-color-primary-white stats-font-adjust">
              {team?.name}
            </span>
            <span className="d-inline-block d-sm-none text-color-primary-white stats-font-adjust">
              {team?.name}
            </span>
          </div>
        </a>
        <div className="col-auto col-md-2 d-none d-md-block text-center stats-font-adjust">
          {team?.matchesPlayed}
        </div>
        <div className="col-3 col-md-3 text-center stats-font-larger stats-font-adjust">
          {orderBy === 'formPerformance' ? (
            <div className="stats-table__form">
              <Form form={team.form} />
            </div>
          ) : (
            stats
          )}
        </div>
      </div>
    </>
  );
}
export default TeamsTableRow;
